module.exports = __webpack_public_path__ + "img/ic_pdf.107a15a3.svg";